import { rowDeletion, RowDeletionInterface, RowDeletionProtectedInterface } from './RowDeletionDecorator';
import { rowEditing, RowEditingInterface, RowEditingProtectedInterface } from './RowEditingDecorator';
import { rowReordering, RowReorderingInterface, RowReorderingProtectedInterface } from './RowReorderingDecorator';
import { rowSelection, RowSelectionInterface, RowSelectionProtectedInterface } from './RowSelectionDecorator';
import { tableFooter, TableFooterProtectedInterface } from './TableFooterDecorator';

export {
  rowDeletion,
  rowEditing,
  rowReordering,
  rowSelection,
  tableFooter,
};

export type {
  RowDeletionInterface,
  RowEditingInterface,
  RowReorderingInterface,
  RowReorderingProtectedInterface,
  RowDeletionProtectedInterface,
  RowSelectionProtectedInterface,
  RowSelectionInterface,
  TableFooterProtectedInterface,
  RowEditingProtectedInterface,
};
